module.exports = __webpack_public_path__ + "static/media/connectino-logo-fa.3ff97c37.svg";